import styled from 'styled-components'

import { _L_Medium, _M_Normal, mainColors } from '@avantstay/backoffice-core'

export const SectionContainer = styled.div`
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const SectionHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  padding: 8px 0;
  margin-bottom: 8px;
`

export const SectionTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const SectionTitle = styled.h3`
  margin: 0;
  color: ${mainColors.black};
  ${_L_Medium};
`

export const SectionDescription = styled.p`
  margin: 4px 0 0;
  color: ${mainColors.neutralExtremelyDark};
  ${_M_Normal};
  white-space: pre-wrap;
`

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 12px;

  svg {
    width: 20px;
    height: 20px;
    color: inherit;
  }
`

export const SubsectionsWrapper = styled.div`
  padding-top: 8px;
  padding-bottom: 8px;
`
